import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// --- NUCLEAR CLEANUP START ---
// This forces the browser to forget the old "sw.js" zombie
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      // If the service worker is the OLD one (sw.js), kill it.
      if (registration.active && registration.active.scriptURL.includes('sw.js')) {
        console.log('Killing Zombie SW:', registration);
        registration.unregister();
      }
    });
  });
}
// --- NUCLEAR CLEANUP END ---

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register();
